<template>
  <div class="text-center">
    <v-dialog persistent v-model="dialog" width="500">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between headline purple accent-4 py-1"
        >
          <div class="subtitle-1 white--text">Patients List</div>
          <div>
            <v-btn @click="closeDialog" class="white--text" icon>
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-card-title>
       
        <v-card-text class="pt-4">
          <ul v-for="data in dotsPatients" :key="data.id">
            <li>
              <p>
                {{ data.patient.name }} /
                {{ data.patient.reg_unique_code }} (Sex:{{
                  data.patient.sex == 1 ? "Male" : "Female"
                }})
              </p>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),

  computed: {
    ...mapState("DotsVolunteer", ["dotsPatients"]),
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
  props: {
    dialog: Boolean,
    localLoading: Boolean,
  },
};
</script>

<style scoped></style>
